export function DataErrorScreen({ error, onRetry }: { error: Error; onRetry: () => void }) {
  return (
    <main className="grid min-h-svh place-items-center bg-atc-base px-6 text-atc-ink">
      <section className="w-full max-w-xl rounded-3xl bg-white p-8 shadow-atc-card md:p-12" role="alert">
        <p className="text-sm font-bold uppercase tracking-[0.28em] text-atc-primary">DATA ERROR</p>
        <h1 className="mt-4 text-2xl font-bold">データを読み込めませんでした</h1>
        <p className="mt-4 leading-relaxed text-atc-slate">数値の正確性を守るため、不完全な状態ではレポートを表示しません。</p>
        <pre className="mt-6 max-h-36 overflow-auto rounded-xl bg-atc-surface p-4 text-xs text-atc-navy">{error.message}</pre>
        <button type="button" onClick={onRetry} className="mt-8 rounded-full bg-atc-primary px-6 py-3 font-bold text-white transition-transform duration-100 active:scale-[.97]">
          もう一度読み込む
        </button>
      </section>
    </main>
  );
}
